/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для информера.
   */
  app.InformerListView = app.View.extend({
    el: '.js-informers',

    additionalOptions: ['informer'],
    /**
     * @inheritDoc
     */
    run: function () {
      if (this.user.get('id')) {
        this.childViews.informerViews = [];
        this.render();
      }
    },
    /**
     * @inheritDoc
     */
    render: function () {

      var that = this;
      _.each(this.informer.models, function (informer, index) {
        var informerUser;

        informerUser = new app.UserInformerItem({
          user_id: that.user.id,
          informer_id: informer.id,
        });
        that.listenTo(informerUser, 'change:is_disabled', that.removeInformer);
        that.childViews.informerViews.push(
          new app.InformerView({
            model: informer,
            informerUser: informerUser,
            number: index + 1,
          })
        );
      });
    },
    /**
     * Удаляем информер
     * @param {app.UserInformerItem} model
     */
    removeInformer: function (model) {
      this.informer.remove(model.get('informer_id'));
    },
  });
})();

}.call(window));